'use strict';

/**
 *
 * @name: brandAnalytics
 *
 */

function BrandAnalyticsFactory($analytics) {

  'ngInject';

  var socialNetwork = function(brandName, network) {

    var properties = {
      eventAction: 'Brand: ' + brandName,
      eventPoints: 0,
      attributes: {
        label: network
      }
    };

    return $analytics.eventTrack('Social Networks', properties);
  };

  var story = function(brandName, storyPath) {

    var properties = {
      eventAction: brandName,
      eventPoints: 0,
      attributes: {
        label: storyPath
      }
    };

    return $analytics.eventTrack('Brand Story', properties);
  };

  var ecommerce = function(brandName, location) {

    var properties = {
      eventAction: brandName,
      eventPoints: 0,
      attributes: {
        label: location
      }
    };

    return $analytics.eventTrack('Brand Ecommerce', properties);
  };

  var mosaic = function(brandName, network) {

    var properties = {
      eventAction: 'Chanel Live: ' + brandName,
      attributes: {
        label: network
      }
    };

    return $analytics.eventTrack('Social Networks', properties);
  };

  return {
    socialNetwork: socialNetwork,
    story: story,
    ecommerce: ecommerce,
    mosaic: mosaic
  };
}

export default BrandAnalyticsFactory;



// WEBPACK FOOTER //
// ./app/pages/member/brand-analytics.factory.js